/**
 * Movie/TV validity checks and genre exclusion.
 * Preserved from v1.
 */

export const ALT_TITLE_RE = /(:|-|&|\(|( and the )|( or ))/i;

export function isBasicValidMovie(c) {
  return c.poster_path && c.release_date && new Date(c.release_date) <= new Date();
}

export function isBasicValidTv(c) {
  return c.poster_path && c.first_air_date && new Date(c.first_air_date) <= new Date();
}

export function isValidMovie(c, excludedGenres) {
  if (!isBasicValidMovie(c)) return false;
  if (excludedGenres?.size && c.genre_ids?.length) return !c.genre_ids.some(id => excludedGenres.has(id));
  return true;
}

export function isValidTv(c, excludedGenres) {
  if (!isBasicValidTv(c)) return false;
  if (excludedGenres?.size && c.genre_ids?.length) return !c.genre_ids.some(id => excludedGenres.has(id));
  return true;
}

export function getExcludedGenreNames(genreIds, excludedGenres) {
  if (!genreIds || !excludedGenres) return [];
  return genreIds.filter(id => excludedGenres.has(id)).map(id => GENRE_NAME[id] || 'Unknown').slice(0, 2);
}

// Re-export GENRE_NAME for use here
import { GENRE_NAME } from './genres.js';
